import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const useStyles = makeStyles()((theme: Theme) => ({
    container: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
        gap: theme.spacing(5),
        paddingBottom: theme.spacing(5),
        overflowY: "auto !important" as "auto",
    },
    warningBox: {
        backgroundColor: theme.palette.emteria.warning,
        display: "flex",
        gap: theme.spacing(2),
    },
    switchLabel: {
        marginBottom: theme.spacing(1),
        fontWeight: 600,
    },
    switchContent: { display: "flex", flexDirection: "column" },
    settingsRows: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(3),
    },
    settingsRow: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        gap: theme.spacing(2),
    },
    apiKeyContainer: {
        display: "flex",
        flex: 1,
        alignItems: "center",
        justifyContent: "space-between",
        gap: theme.spacing(2),
        flexWrap: "wrap",
    },
    apiKeyActions: {
        display: "flex",
        gap: theme.spacing(1),
    },
    versionDisplay: {
        color: "gray",
        fontSize: "12px",
        opacity: 0.6,
        marginTop: "auto",
    },
    formContainer: {
        width: "100%",
    },
    formGrid: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: theme.spacing(3),
        [theme.breakpoints.down("md")]: {
            gridTemplateColumns: "1fr",
        },
    },
    formField: {
        minWidth: 0,
        marginBottom: theme.spacing(3),
    },
    phoneRow: {
        display: "flex",
        gap: theme.spacing(1),
        alignItems: "flex-start",
        width: "100%",
        minWidth: 0,
        "& > *": { flex: 1, minWidth: 0 },
    },
    fullWidthSection: {
        gridColumn: "1 / -1",
    },
    sectionHeader: {
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(1),
        fontWeight: 600,
        fontSize: 16,
    },
    formLabel: {
        fontSize: "16px",
    },
    tabPanel: {
        padding: 0,
    },
    tabPanelBilling: {
        padding: 0,
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(5),
    },
    loadingContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: 420,
    },
    loadingBox: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: 120,
        flexDirection: "column",
        gap: theme.spacing(2),
    },
    confirmDialogParagraph: {
        marginBottom: theme.spacing(2),
    },
    confirmDialogListTitle: {
        fontWeight: 600,
        marginBottom: theme.spacing(1),
    },
    confirmDialogList: {
        margin: 0,
        paddingLeft: theme.spacing(3),
    },
    descriptionText: {
        marginBottom: theme.spacing(2),
    },
    formInfoText: {
        marginBottom: theme.spacing(1),
    },
    switcherBox: {
        width: 200,
    },
}));
